module.exports = __webpack_public_path__ + "static/img/find-playtesters.8851b82.png";


//////////////////
// WEBPACK FOOTER
// ./LandingPageTemp/Assets/find-playtesters.png
// module id = 5Izj
// module chunks = 1